// <WorkspaceSwitcher> — Epic 2 · S2.2.
//
// Renders ONLY when fn_my_workspaces returns >1 entry. One entry → no switcher
// (the product simply is their workspace). The switcher is a lens, not a
// filter — switching it changes who is looking, not what data is shown.
//
// The wall is the database — the switcher is a convenience. A workspace
// someone doesn't hold returns nothing regardless of what the menu shows.

import React from "react";
import { useWorkspace } from "../../contexts/WorkspaceContext";

export default function WorkspaceSwitcher({ className = "" }) {
  const { workspaces, activeWorkspaceId, switchWorkspace, hasMultiple } =
    useWorkspace();

  if (!hasMultiple) return null;

  return (
    <select
      value={activeWorkspaceId || ""}
      onChange={(e) => switchWorkspace(e.target.value)}
      className={`text-sm rounded-lg border border-gray-200 dark:border-gray-700
        bg-white dark:bg-gray-900 px-3 py-1.5 text-gray-700 dark:text-gray-200
        focus:outline-none focus-visible:ring-2 focus-visible:ring-[#32B1FF]
        ${className}`}
      aria-label="Switch workspace"
      data-testid="workspace-switcher"
    >
      {workspaces.map((ws) => {
        const id = ws.workspace || ws.id;
        return (
          <option key={id} value={id}>
            {ws.label || id}
          </option>
        );
      })}
    </select>
  );
}
